import React from 'react';

import EntityHistoryTab, { HistoryEntryMapping } from 'components/Entities/EntityHistoryTab/EntityHistoryTab';
import type { TabComponentProps } from 'components/Entities/EntityDetailsContent/types';

import { RiskControlEventValue } from 'utils/api/modules/entities/entities.types';

import RiskControlEventRow from './RiskControlEventRow';
import { RISK_CONTROL_EVENT_KEY } from './riskControlEvent';

export const RISK_HISTORY_MAPPING: HistoryEntryMapping = {
  [RISK_CONTROL_EVENT_KEY]: {
    Row: RiskControlEventRow,
    rowKey: ({ current }) => {
      const { event, control } = current as unknown as RiskControlEventValue;
      return `${event}-${control.uuid ?? control.name}`;
    },
  },
};

const RiskHistoryTab: React.FunctionComponent<TabComponentProps> = ({ store }) => (
  <EntityHistoryTab store={store} mapping={RISK_HISTORY_MAPPING} />
);

export default RiskHistoryTab;
